import { useEffect, useState } from "react";
import { Loader2, Save } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";
import api from "@/lib/api";
import { useSeo } from "@/hooks/useSeo";

const Field = ({ label, hint, children }) => (
  <div>
    <label className="text-sm font-medium text-slate-700">{label}</label>
    {hint && <p className="text-xs text-slate-400">{hint}</p>}
    <div className="mt-1.5">{children}</div>
  </div>
);

const AdminVisiMisi = () => {
  const [f, setF] = useState({});
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  useSeo("Kelola Visi & Misi");

  useEffect(() => {
    api.get("/vision-mission").then((r) => {
      const d = r.data || {};
      setF({
        vision: d.vision || "",
        missions_text: (d.missions || []).join("\n"),
        goals_text: (d.goals || []).join("\n"),
        values_text: (d.values || []).join("\n"),
      });
    }).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const toArr = (t) => (t || "").split("\n").map((x) => x.trim()).filter(Boolean);

  const save = async () => {
    setSaving(true);
    try {
      await api.put("/vision-mission", {
        vision: f.vision,
        missions: toArr(f.missions_text),
        goals: toArr(f.goals_text),
        values: toArr(f.values_text),
      });
      toast.success("Visi & Misi berhasil disimpan");
    } catch { toast.error("Gagal menyimpan"); }
    finally { setSaving(false); }
  };

  if (loading) return <div className="flex justify-center py-20"><Loader2 className="h-8 w-8 animate-spin text-emerald-600" /></div>;

  return (
    <div>
      <h1 className="font-heading text-2xl font-bold text-slate-900">Kelola Visi & Misi</h1>
      <p className="mt-1 text-sm text-slate-500">Perbarui visi, misi, tujuan, dan nilai-nilai pendidikan.</p>

      <div className="mt-6 space-y-5 rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
        <Field label="Visi"><Textarea rows={3} value={f.vision} onChange={(e) => setF({ ...f, vision: e.target.value })} data-testid="vm-vision-input" /></Field>
        <Field label="Misi" hint="Satu poin per baris"><Textarea rows={6} value={f.missions_text} onChange={(e) => setF({ ...f, missions_text: e.target.value })} data-testid="vm-missions-input" /></Field>
        <Field label="Tujuan Sekolah" hint="Satu poin per baris"><Textarea rows={5} value={f.goals_text} onChange={(e) => setF({ ...f, goals_text: e.target.value })} data-testid="vm-goals-input" /></Field>
        <Field label="Nilai-Nilai Pendidikan" hint="Satu nilai per baris"><Textarea rows={4} value={f.values_text} onChange={(e) => setF({ ...f, values_text: e.target.value })} data-testid="vm-values-input" /></Field>

        <Button onClick={save} disabled={saving} className="gap-2 bg-emerald-700 hover:bg-emerald-800" data-testid="vm-save-button">
          {saving ? <Loader2 className="h-4 w-4 animate-spin" /> : <Save className="h-4 w-4" />} Simpan Perubahan
        </Button>
      </div>
    </div>
  );
};

export default AdminVisiMisi;
